
import { fetchTimeInterval,getCurrentDate, getCurrentTime, isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { ItentificationTypeOptions } from "../../../../../../utils/constant";
import { fetchProviderList } from "./NonDOTExamBPVisionAudio1";

export const DrugScreenCollection = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: true,
      };
    const charts = [{
        type:'Grid',
        col:'col-lg-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-lg-9',
        data:[
            {
                id:'testing_details',
                label:'Result Details',
                data:[{
                    label:'Testing Details',
                    labelStyle: "fw-semibold",
                    fields:[{
                        label:'Arrival Date',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'Date',
                        name:'arrival_date',
                        required:true,
                    },
                    {
                        label:'Arrival Time',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        name:'arrival_time',
                        type: "SelectSearchList",
                        placeholder:'Time',
                        isAsync:true,
                        options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                        loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                        required:true,
                    },
                    {
                        label:'Alternate ID',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        placeholder:'Alternate ID',
                        name:'alternate_id',
                    },
                    {
                        label:'Donor ID',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        options:ItentificationTypeOptions,
                        name:'donor_id',
                        required:true,
                    },
                    {
                        label:'Donor ID Number',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        name:'donor_id_number',
                        required:true,
                    },
                    {
                        label:'State',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        options:props.stateList,
                        name:'state',
                        required:true,
                    },{
                        label:'DOT Agency',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        name:'dot_agency',
                        id:'dot_agency',
                        options:optionsToKeyValuePairs(['FMCSA','FAA','FRA','FTA','PHMSA','USCG']),
                        required:true,
                    },
                    {
                        label:'Collection Type',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        name:'collection_type',
                        id:'collection_type',
                        required:true,
                        options:optionsToKeyValuePairs(['Split','Single','None Provided']),
                        required:true,
                    },
                    {
                        label:'Collection Remarks',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        rules:[{rule:[{field:'collection_type',value:'None Provided',operator:'==='}],action:'REQUIRED'}],
                        name:'collection_remarks',
                        placeholder:'Collection Remarks',
                    },{
                        label:'Drug Tests to be Performed',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'RadioGroup',
                        name:'drugs_tests',
                        id:'drugs_tests',
                        options:['Urine','Oral Fluid'],
                        required:true,
                    },{
                        label:'Chain of Custody No',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        placeholder:'Chain of Custody No',
                        name:'chain_of_custody_no',
                        required:true,
                    },
                    {
                        label:'Sample ID',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        name:'sample_id',
                        placeholder:'Sample ID',
                    },
                    {
                        label:'Reason',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        name:'reason',
                        id:'reason',
                        options:optionsToKeyValuePairs(['Pre-employment','Followup','Random','Post Accident','Return to Duty','Other','Reasonable Suspicion/Cause']),
                        required:true,
                    },
                    {
                        label:'Specify Other Reason Time',
                        ...stackedFieldStyle,
                        type:'TextArea',
                        col:'col-6 border-0',
                        name:'other_reason',
                        placeholder:'Specify Other Reason Time',
                        disabled:true,
                        id:'other_reason',
                        rules:[{rule:[{field:'reason',value:'Other',operator:'==='}],action:'ENABLE'}],
                    }]
                },
                {
                    label:'Activity Details - '+props.activityName,
                    labelStyle: "fw-semibold",
                    fields:[{
                        label:'Result Date',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'Date',
                        name:'result_date',
                    },
                    {
                        label:'Result Time',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'TextInput',
                        name:'result_time',
                        placeholder:'Time',
                        type: "SelectSearchList",
                        isAsync:true,
                        options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                        loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                    }
                ]
                },
        //         {
        //             label:'Signs of Adulteration',
        //             note:'specimen temperature must be read within 4 minutes of collection.',
        //             col:'col-12',
        //             fields:[{
        //                 label:'Signs of adulteration include:',
        //                 notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
        //                 type:'YesOrNoTable',
        //                 col:'col-8',
        //                 defaultBtnLabel:'Set all to Normal',
        //                 defaultValues:{new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1,temperature_range_second_read: 1},
        //                 options:[{label:'Yes',value:1},{label:'No',value:0}],
        //                 list:[
        //             { 
        //                 label: 'Any sign of adulteration?', 
        //                 name: 'new_adulteration_signs',
        //                 failedValue: [1] 
        //             },
        //             { 
        //                 label: 'In temperature range?', 
        //                 name: 'temperature_range', 
        //                 failedValue: [0] 
        //             },
        //             { 
        //                 label: 'Is there a sufficient quantity?', 
        //                 name: 'sufficient_quantity', 
        //                 failedValue: [0]
        //             },
        //             { 
        //                 label: 'In temperature range? (2nd read)?', 
        //                 name: 'temperature_range_second_read',
        //                 failedValue: [0] 
        //             }
        //         ],
        //     }]
        // },
        {
            label:'Signs of Adulteration',
            labelStyle: "fw-semibold",
            note:'specimen temperature must be read within 4 minutes of collection.',
            col:'col-12',
            fields:[
                  {
                      type:'AdulterationForm',
                      label:'Signs of adulteration include:',
                      notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
                  },
                  {
                    label:'Signs of adulteration',
                    notes:['unusual color','unusual smell','foreign objects in specimen','unusual behavior by donor'],
                    type:'NewYesOrNoTable',
                    options:[{label:'Yes',value:1},{label:'No',value:0}],
                    defaultBtnLabel:'All Normal',
                    defaultValues:{new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1,temperature_range_second_read:1},
                    list:[
                         {label:'Any sign of adulteration?',name:'new_adulteration_signs',failedValue:[1]},
                         {label:'In temperature range?',name:'temperature_range',failedValue: [0]},
                         {label:'Is there a sufficient quantity?',name:'sufficient_quantity',failedValue:[0]},
                         { label: 'In temperature range? (2nd read)?',name: 'temperature_range_second_read',failedValue: [0]},    
                         ],
                  }]
      },
                {
                    label:'Shipping Information',
                    labelStyle: "fw-semibold",
                    col:'col-6',
                    fields:[{
                        label:'Shipping Service',
                        ...stackedFieldStyle,
                        col:'col-6 border-0',
                        type:'SelectList',
                        options:isSet(props.lookupsOptions['shippingService'],[]),
                        name:'shipping_service',
                    },
                    {
                        label:'Shipping Billing No.',
                        ...stackedFieldStyle,
                        placeholder:'Shipping Billing No.',
                        col:'col-6 border-0',
                        type:'TextInput',
                        name:'shipping_billing_no',
                    },
                ]
                },
                {
                    label: "Review / Completion",
                    labelStyle: "fw-semibold",
                    fields: [
                        {
                            type: "ProviderSignOff",
                            col: "col-12",
                            fields: [
                                { label: "Signature PIN", name: "provider_pin", col: "col-12" },
                                { label: "Signature", type: "NewSignature", name: "provider_signature", col: "col-12" },
                                { label: "Date", type: "Date", name: "signed_date", col: "col-12" },
                                { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive'],false),statusBasedColor: true,},
                                { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled'],false),statusBasedColor: true },
                            ],
                        },
                    ],
                }
            ]
            },
            {
                id:'LabDetailsMROReview',
                label:'Lab Details / MRO Review',
                data:[
                    {
                        label:'Lab Details',
                        labelStyle: "fw-semibold",
                        fieldProps: stackedFieldStyle,
                        fields:[
                            {
                                label:'Lab Name',
                                type:'TextInput',
                                Max:200,
                                name:'lab_name',
                                placeholder:'Lab Name',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Specimen Received Date',
                                name:'lab_received_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Specimen Received Time',
                                name:'lab_received_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-6 border-0',
                                isAsync:true,
                            }, 
                            {
                                label:'Lab Reported Date',
                                name:'lab_reported_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-6 border-0',
                            },
                            {
                                label:'Lab Reported Time',
                                name:'lab_reported_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-6 border-0',
                                isAsync:true,
                            }, 
                        ],
                    },
                    {
                        label:'MRO Review Determination',
                        labelStyle: "fw-semibold",
                        fieldProps: stackedFieldStyle,
                        fields:[
                            {
                                label:'MRO Verification Status',
                                type:'SelectList',
                                options: optionsToKeyValuePairs([
                                    'Not Started',
                                    'Pending Lab Result',
                                    'Pending MRO Review',
                                    'Under Review',
                                    'Verified Negative',
                                    'Verified Positive',
                                    'Cancelled'
                                ]),                                
                                name:'mro_verification_status',
                                col:'col-4 border-0',
                            },
                            {
                                label:'MRO Verified Result',
                                type:'SelectList',
                                options: optionsToKeyValuePairs([
                                    'Negative',
                                    'Positive',
                                    'Cancelled',
                                    'Inconclusive',
                                    'Pending',
                                    'Refused',
                                    'Invalid',
                                    'Dilute'
                                ]),
                                name:'mro_verified_result',
                                placeholder:'MRO Verified Result',
                                col:'col-4 border-0',
                            },
                            {
                                label: "Verified By (Medical Review Officer)",
                                type: 'SelectSearchList',
                                isAutoPopulate: true,
                                placeholder: 'Medical Review Officer',
                                isAsync: true,
                                options: [],
                                loadCallBack: (val, callback) => fetchProviderList(val, props, callback),
                                name: 'verified_by',
                                id: 'verified_by',
                                col: 'col-4 border-0',
                            },
                            {
                                label:'Verification Date',
                                name:'verification_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-4 border-0',
                            },
                            {
                                label:'Verification Time',
                                name:'verification_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-4 border-0',
                                isAsync:true,
                            },
                            {
                                label:'Signed Date',
                                name:'mro_signed_date',
                                type: "Date",
                                placeholder:'Date',
                                col:'col-4 border-0',
                            },
                            {
                                label:'Signed Time',
                                name:'mro_signed_time',
                                type: "SelectSearchList",
                                placeholder:'Time',
                                options:[{'label':getCurrentTime(),value:getCurrentTime()}],
                                loadCallBack:(val,callback)=>fetchTimeInterval(val,callback),
                                col:'col-4 border-0',
                                isAsync:true,
                            },
                            { 
                                label : "ReviewStatus", 
                                type: "SelectList", 
                                name: "review_status", 
                                col: "col-4 border-0", 
                                options: optionsToKeyValuePairs([
                                    'Not Started',
                                    'Pending',
                                    'In Review',
                                    'Completed',
                                    'Cancelled'
                                ],false),                                
                                statusBasedColor: true 
                            },

                        ],
                    },
                    {
                        label:'MRO Comments ',
                        labelStyle: "fw-semibold",
                        fieldProps: stackedFieldStyle,
                        fields:[
                            {
                                col:'col-12',
                                type: "TextArea",
                                label: "Notes",
                                placeholder: "Add Comments",
                                className: "form-control form-control-solid",
                                name: "notes",
                                col: "col-12 border-0",
                                name:'notes',
                            },
                      ]
                    },
                ],
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const buttons = {
        label: false,
        result: false,
        showDrugScreenPrintActions: true,
    };
    const defaultValue = {
        arrival_date:getCurrentDate(),
        arrival_time:getCurrentTime(),
        result_time:'',
        result_date:'',
        donor_id:isSet(props?.employeeDetails?.identification_type,''),
        donor_id_number:isSet(props?.employeeDetails?.identification_number,''),
        dot_agency:'FMCSA',
        collection_type:'Split',
        drugs_tests:'Urine',
        status:'Not Started',
        activity_status:'Not Started',
        // new_adulteration_signs:0,
        // sufficient_quantity:0,
        // temperature_range:0,
        // temperature_range_second_read:0,
        // reason:'Pre-employment'
    };
    /** Same as NewDrugScreenRapidPanel: tabs render in-body (sh_subnav), not modal header. */
    const headers = [];
    return {charts,defaultValue,buttons,headers,computationFunction: (formData,key) => ({...computationRules(formData,key), ...computationRules1(formData,key)})};
}

export const computationRules1 = (formData,key,type='drugscreen')=>{
    let returnResult = {};
    
    // Update activity_status based on status changes
    if(key === 'status' && formData.status) {
        const status = formData.status;
        
        switch(status) {
            case 'Not Started':
                returnResult.activity_status = 'Not Started';
                break;
            case 'Pending':
                returnResult.activity_status = 'Pending';
                break;
            case 'Normal':
                returnResult.activity_status = 'Completed';
                break;
            case 'Abnormal':
                returnResult.activity_status = 'Completed';
                break;
            case 'Negative':
                returnResult.activity_status = 'Completed';
                break;
            case 'Positive':
                returnResult.activity_status = 'Completed';
                break;
            case 'Dispensed':
                returnResult.activity_status = 'Completed';
                break;
            case 'Administered':
                returnResult.activity_status = 'Completed';
                break;
            case 'Failed':
                returnResult.activity_status = 'Completed';
                break;
            case 'Passed':
                returnResult.activity_status = 'Completed';
                break;
            case 'Non-Negative':
                if(type==='lab'){
                    returnResult.activity_status = 'Pending Lab Confirmation';
                }else{
                    returnResult.activity_status = 'Pending MRO Confirmation';
                }
                break;
            case 'Cancelled':
                returnResult.activity_status = 'Cancelled';
                break;
            case 'Inconclusive':
                if(type==='lab'){
                    returnResult.activity_status = 'Pending Lab Confirmation';
                }else{
                    returnResult.activity_status = 'Pending MRO Confirmation';
                }
                break;
            default:
                // No change if status doesn't match any case
                break;
        }
    }
    // const adulteration = {new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1};
    // const notadulterated = {new_adulteration_signs:1,sufficient_quantity:0,temperature_range:0,temperature_range_second_read:0};
    // const adulterationEqual = Object.entries(adulteration).every(([key, value]) => formData[key] === value);
    // const notadulteratedEqual = Object.entries(notadulterated).every(([key, value]) => formData[key] === value);
    
    // if(!isSet(key) 
    //     || key === 'new_adulteration_signs' 
    //     || key === 'temperature_range' 
    //     || key === 'sufficient_quantity' 
    //     || key === 'temperature_range_second_read'){
    //         if (adulterationEqual===true) {
    //             returnResult.status = 'Negative';
    //             returnResult.activity_status = 'Completed';
    //         }else if(notadulteratedEqual===true){
    //             returnResult.status = 'Non-Negative';
    //             returnResult.activity_status = 'Pending MRO Confirmation';
    //         }else{
    //             returnResult.status = 'Pending';
    //             returnResult.activity_status = 'Pending';
    //         }
    //     }
    
    return returnResult;
}

const computationRules = (formData,key)=>{
    let returnResult = {};
    // if(key==='status' && formData.status==='Not Started' ){
    //     return {
    //       status: 'Not Started',
    //       activity_status: 'Not Started'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Pending Result' ){
    //     return {
    //       activity_status: 'In Progress'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Negative'){
    //     return {
    //       activity_status: 'Passed'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Non-Negative'){
    //     return {
    //       activity_status: 'Pending confirmation'
    //     };
    //   }
    //   if(key==='status' && formData.status==='Confirmatory Pending'){
    //     return {
    //       activity_status: 'In Progress'
    //     };
    //   }
    //   if(key==='status' && (formData.status==='Confirmed Negative'||formData.status==='Confirmed Positive') && (formData.provider_signature==='' || formData.provider_signature===null || formData.provider_signature===undefined)){
    //     return {
    //       activity_status: 'Pending MRO Review'
    //     };
    //   }
    //   if((key==='provider_signature' || key==='status') && (formData.provider_signature!='' && formData.provider_signature!=null && formData.provider_signature!=undefined) && formData.status==='Confirmed Negative'){
    //     return {
    //       activity_status: 'Passed'
    //     };
    //   }
    //   if((key==='provider_signature' || key==='status') && (formData.provider_signature!='' && formData.provider_signature!=null && formData.provider_signature!=undefined) && formData.status==='Confirmed Positive'){
    //     return {
    //       activity_status: 'Failed'
    //     };
    //   }
    // Avoid feedback loops when status or activity_status themselves are being changed
    if (key === "status" || key === "activity_status") {
        return {};
    }

    const currentStatus = isSet(formData.status, "Not Started");
    const currentActivityStatus = isSet(formData.activity_status, "Not Started");

    // If user changes any field while both status and activity_status are "Not Started",
    // move to Pending Result / In Progress
    if (currentStatus === "Not Started" && currentActivityStatus === "Not Started" && key) {
        returnResult.status = "Pending";
        returnResult.activity_status = "Pending";
    }

    // Handle adulteration-based status calculation
    const adulteration = {new_adulteration_signs:0,sufficient_quantity:1,temperature_range:1};
    const notadulterated = {new_adulteration_signs:1,sufficient_quantity:0,temperature_range:0,temperature_range_second_read:0};
    const adulterationEqual = Object.entries(adulteration).every(([key, value]) => formData[key] === value);
    const notadulteratedEqual = Object.entries(notadulterated).every(([key, value]) => formData[key] === value);
    
    if(!isSet(key) 
    || key === 'new_adulteration_signs' 
    || key === 'temperature_range' 
    || key === 'sufficient_quantity' 
    || key === 'temperature_range_second_read'){
        if (adulterationEqual===true) {
            returnResult.status = 'Negative';
            returnResult.activity_status = 'Completed';
        }else if(notadulteratedEqual===true){
            returnResult.status = 'Non-Negative';
            returnResult.activity_status = 'Pending MRO Confirmation';
        }else{
            returnResult.status = 'Pending';
            returnResult.activity_status = 'Pending';
        }
    }


    return returnResult;
}